module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1033.d835086d.png";